import { useIntervalFn } from '@vueuse/core';
import type { User } from 'firebase/auth';
import { onAuthChange, signIn, logout, getAuthToken } from '~/helpers/auth';

type State = 'pending' | 'logged_in' | 'logged_out';

const ONE_HOUR = 3_600_000;

export default function useAuth() {
  const token = useState(() => '');
  const authState = useState<State>((): State => 'pending');
  const user = ref<User | null>();

  watch(user, tokenize);

  onAuthChange(_user => user.value = _user);
  watch(user, user => authState.value = user ? 'logged_in' : 'logged_out');

  useIntervalFn(tokenize, ONE_HOUR);

  return {
    loggedIn: computed(() => authState.value == 'logged_in'),
    authState,
    logout,
    signIn,
    onAuthChange(cb: (auth: State) => void) {
      watch(authState, cb);
    }
  };

  async function tokenize() {
    token.value = user.value ? await getAuthToken() : '';
  }
}